export default {
  en: {
    navbarTitle: "Attacks",
    title: "Attack",
    create: "Create an Attack",
    search: "Search Attack",
    new: "New Attack",
    review: "Review Attack",
    chooseAdversary: "Choose an Adverary",
    adversarySearch: "Search an Adversary",
    adversarySelected: "Selected",
    attackName: "Attack Name",
    attackNamePlaceholder: "Insert Attack Name",
    execution: "Execution",
    executionAuto: "Run autonomously",
    executionManual: "Require manual approval",
    parser: "Parser",
    parserDefault: "Use default parsers",
    parserNotDefault: "Do not use default parsers",
    autoClose: "Auto-close",
    autoCloseForever: "Keep open forever",
    autoCloseOperation: "Auto close operation",
    runState: "Run state",
    runStateImmediately: "Run immediately",
    runStateOnStart: "Pause on start",
    obfuscator: "Obfuscator",
    jitter: "Jitter",
    jitterSec: "(sec/sec)",
    jitterMin: "min",
    jitterMax: "max",
    jitterRule: "cannot be less than the minimum",
    jitterReset: "Reset",
    manual: "Manual",
    auto: "Automatic",
    currentState: "Current State",
    state: {
      running: "Running",
      run_one_link: "Run one link",
      paused: "Paused",
      out_of_time: "Out of time",
      finished: "Finished",
      cleanup: "Cleanup",
      limit: "Waiting"
    },
    attackQueue: "Attack Queue",
    abilityState: {
      high_viz: "high_viz",
      untrusted: "Untrusted",
      execute: "Running",
      discard: "Discarded",
      pause: "Paused",
      success: "Success",
      error: "Failed",
      waiting: "Waiting",
      next: "Next",
      timeout: "Timeout",
      notStarted: "Not started",
      notStartedText: "Operation waiting to start",
      limit: "Waiting Queue",
      failedStart: "Failed to start",
      failedStartText: "Operation failed to start",
      interrupted: "Interrupted"
    },
    lastRan: "Last ran",
    progress: "Attack Progress",
    addAbility: "Add Ability",
    searchAnAbility: "Search an Ability",
    addCommand: "Add Command",
    paused: "Paused",
    pending: "Pending",
    discarded: "Discarded",
    progressStatus: "Progress",
    deleteTitle: "Delete the Attack",
    deleteDescription:
      "Are you sure that you want to delete the attack {attackName}?",
    stopTitle: "Stop the Attack",
    stopDescription:
      "Are you sure that you want to stop the attack {attackName}?",
    failed: "Failed",
    success: "Success",
    availableAgents: {
      totalAgents: "Agents",
      placeholderSelectAgent: "Select an available agent",
      titleModalUnavailableAgents: "No avaliable agent was found",
      descriptionModalUnavailableAgents:
        "Make sure to have an avaliable agent so you can deploy your attack.",
      buttonActiveNewAgent: "Activate Agent"
    },
    timelineFields: {
      platform: "OS",
      timestamps: "Time Stamp",
      status: "Status",
      ability: "Ability",
      agent: "Agent",
      host: "Host",
      pid: "pid",
      details: "Details"
    },
    nextInLine: "Next in line",
    inProgress: "In progress",
    viewInfo: {
      buttonText: "View Info",
      buttonTextRunningCommand: "Review Command",
      loot: "Loot",
      lootFields: {
        name: "Name",
        value: "Value"
      },
      error: "Error"
    },
    reviewCommand: {
      approve: "Approve",
      reprove: "Reprove"
    },
    controls: {
      reload: "Restart Operation"
    },
    uncompletedOperation: {
      tooltip: "Attack without conclusion",
      title: "Important: Attack Guidelines",
      description:
        "You have noticed that when you finished the planned attack it was completed, but did not reach 100% progress. This may have happened for some of the following reasons:",
      reasons: {
        manuallyFinished: "Attack was manually terminated",
        agentConnectionLost: "Connection to the Agent was lost",
        abilityCancelled:
          "The Ability was cancelled. It happens when we click on “Next”",
        abilityNotMatchSO: "Ability incompatible with the Operational System"
      }
    },
    report: {
      modalDownload: {
        title: "Select you report format",
        pdfButton: "Download .PDF",
        csvButton: "Download .CSV"
      }
    },
    list: {
      title: "Attack | Attacks",
      searchField: {
        attack_name: "Attack Name",
        adversary_name: "Adversary Name",
        agent_name: "Agent Name",
        ability_name: "Ability Name"
      },
      table: {
        attack_name: "Attack Name",
        adversary_name: "Adversary",
        operation_date: "Data",
        agent_name: "Agent",
        agent_so: "OS",
        qty_abilities: "Abilities",
        success_percent: "Attack %"
      }
    },
    reviewPage: {
      facts: "Fact | Facts",
      rules: "Rule | Rules",
      title: "Review your Attack",
      startAttack: "Start Attack",
      factsAndRules: "Facts / Rules",
      advancedConfiguration: "Advanced Settings",
      variableUsed:
        "No {variable} will be used for this attack | {qty} {variable} will be used by this attack | {qty} {variable} will be used by this attack",
      addVariable: "Add {variable}",
      searchByVariable: "Search a {variable}",
      obfuscatorPlaceholder: "Select an available Obfuscator"
    }
  },
  pt: {
    navbarTitle: "Ataques",
    title: "Ataque",
    create: "Criar um Ataque",
    search: "Buscar Ataque",
    new: "Novo Ataque",
    review: "Rever Ataque",
    chooseAdversary: "Escolha um Adversário",
    adversarySearch: "Pesquisar um Adversário",
    adversarySelected: "Selecionado",
    attackName: "Nome do Ataque",
    attackNamePlaceholder: "Inserir Nome de Ataque",
    execution: "Execução",
    executionAuto: "Funciona de forma autônoma",
    executionManual: "Exigir aprovação manual",
    parser: "Parser",
    parserDefault: "Usar parsers padrão",
    parserNotDefault: "Não usar parsers padrão",
    autoClose: "Auto-fechamento",
    autoCloseForever: "Mantenha-se aberto para sempre",
    autoCloseOperation: "Operação de fechamento automático",
    runState: "Estado de funcionamento",
    runStateImmediately: "Executar imediatamente",
    runStateOnStart: "Pausa no início",
    obfuscator: "Ofuscador",
    jitter: "Jitter",
    jitterSec: "(seg/seg)",
    jitterMin: "mín",
    jitterMax: "máx",
    jitterRule: "não pode ser menor que o mínimo",
    jitterReset: "Reset",
    manual: "Manual",
    auto: "Automática",
    currentState: "Estado atual",
    state: {
      running: "Executando",
      run_one_link: "Executar um link",
      paused: "Pausado",
      out_of_time: "Tempo esgotado",
      finished: "Finalizado",
      cleanup: "Cleanup",
      limit: "Esperando"
    },
    attackQueue: "Fila de Ataques",
    abilityState: {
      high_viz: "high_viz",
      untrusted: "Inconfiável",
      execute: "Executando",
      discard: "Descartado",
      pause: "Pausado",
      success: "Sucesso",
      error: "Falhou",
      waiting: "Aguardando",
      next: "Próximo",
      timeout: "Tempo esgotado",
      notStarted: "Não iniciada",
      notStartedText: "Operação aguardando para iniciar",
      limit: "Esperando na fila",
      failedStart: "Falhou ao iniciar",
      failedStartText: "A operação falhou ao iniciar",
      interrupted: "Interrompida"
    },
    lastRan: "Última execução",
    progress: "Progresso do ataque",
    addAbility: "Adicionar Habilidade",
    searchAnAbility: "Buscar uma habilidade",
    addCommand: "Adicionar Comando",
    paused: "Pausado",
    pending: "Pendente",
    discarded: "Descartado",
    progressStatus: "Progresso",
    deleteTitle: "Excluir o Ataque",
    deleteDescription:
      "Você tem certeza de que deseja excluir o ataque {attackName}?",
    stopTitle: "Parar o Ataque",
    stopDescription:
      "Você tem certeza de que deseja parar o ataque {attackName}?",
    failed: "Falhou",
    success: "Sucesso",
    availableAgents: {
      totalAgents: "Agentes",
      placeholderSelectAgent: "Selecione um agente disponível",
      titleModalUnavailableAgents: "Nenhum agente disponível foi encontrado",
      descriptionModalUnavailableAgents:
        "Certifique-se de ter um agente disponível para que você possa implantar seu ataque.",
      buttonActiveNewAgent: "Ativar Novo Agente"
    },
    timelineFields: {
      platform: "OS",
      timestamps: "Time Stamp",
      status: "Status",
      ability: "Habilidade",
      agent: "Agente",
      host: "Host",
      pid: "pid",
      details: "Detalhes"
    },
    nextInLine: "Próximo na fila",
    inProgress: "Em progresso",
    viewInfo: {
      loot: "Loot",
      buttonText: "Ver Informações",
      buttonTextRunningCommand: "Revisar Comando",
      lootFields: {
        name: "Nome",
        value: "Valor"
      },
      error: "Erro"
    },
    reviewCommand: {
      approve: "Aprovar",
      reprove: "Reprovar"
    },
    controls: {
      reload: "Reiniciar Operação"
    },
    uncompletedOperation: {
      tooltip: "Ataque sem conclusão",
      title: "Importante: Orientações sobre Ataque",
      description:
        "Você percebeu que ao finalizar o ataque planejado ele foi concluído, porém não atingiu 100% de progresso. Isso pode ter acontecido por alguns dos motivos abaixo:",
      reasons: {
        manuallyFinished: "Ataque foi finalizado manualmente",
        agentConnectionLost: "Ocorreu perda de conexão com o Agente",
        abilityCancelled:
          "A Habilidade foi cancelada. Acontece quando clicamos em “Next”",
        abilityNotMatchSO: "Habilidade incompatível com o Sistema Operacional"
      }
    },
    report: {
      modalDownload: {
        title: "Selecione o formato do relatório",
        pdfButton: "Baixar .PDF",
        csvButton: "Baixar .CSV"
      }
    },
    list: {
      title: "Ataque | Ataques",
      searchField: {
        attack_name: "Nome do Ataque",
        adversary_name: "Nome do Adversário",
        agent_name: "Nome do Agente",
        ability_name: "Nome da Habilidade"
      },
      table: {
        attack_name: "Nome do Ataque",
        adversary_name: "Adversário",
        operation_date: "Data",
        agent_name: "Agente",
        agent_so: "SO",
        qty_abilities: "Habilidades",
        success_percent: "Ataque %"
      }
    },
    reviewPage: {
      facts: "Fact | Facts",
      rules: "Regra | Regras",
      title: "Revise seu Ataque",
      startAttack: "Iniciar Ataque",
      factsAndRules: "Facts / Regras",
      advancedConfiguration: "Configurações Avançadas",
      variableUsed:
        "Não há {variable} que este Ataque poderá utilizar | {qty} {variable} que este Ataque poderá utilizar | {qty} {variable} que este Ataque poderá utilizar",
      addVariable: "Adicionar {variable}",
      searchByVariable: "Pesquisar {variable}",
      obfuscatorPlaceholder: "Selecione um Ofuscador disponível"
    }
  },
  es: {
    navbarTitle: "Ataques",
    title: "Ataque",
    create: "Crear un ataque",
    search: "Buscar Ataque",
    new: "Nuevo Ataque",
    review: "Revisión Ataque",
    chooseAdversary: "Elija un adversario",
    adversarySearch: "Búsqueda de un adversario",
    adversarySelected: "Seleccionado",
    attackName: "Nombre del ataque",
    attackNamePlaceholder: "Inserte el nombre del ataque",
    execution: "Ejecución",
    executionAuto: "Funciona de forma autónoma",
    executionManual: "Requiere aprobación manual",
    parser: "Parser",
    parserDefault: "Utilizar parsers estándar",
    parserNotDefault: "No utilice los parsers estándar",
    autoClose: "Autocierre",
    autoCloseForever: "Mantener abierto para siempre",
    autoCloseOperation: "Operación de cierre automático",
    runState: "Estado de ejecución",
    runStateImmediately: "Corre inmediatamente",
    runStateOnStart: "Pausa al inicio",
    obfuscator: "Ofuscador",
    jitter: "Jitter",
    jitterSec: "(seg/seg)",
    jitterMin: "min",
    jitterMax: "max",
    jitterRule: "no puede ser inferior al mínimo",
    jitterReset: "Reset",
    manual: "Manual",
    auto: "Automática",
    currentState: "Situación actual",
    state: {
      running: "Ejecutar",
      run_one_link: "Ejecutar un enlace",
      paused: "En pausa",
      out_of_time: "Tiempo de espera",
      finished: "Terminado",
      cleanup: "Cleanup",
      limit: "Espera"
    },
    attackQueue: "Cola de Ataques",
    abilityState: {
      high_viz: "high_viz",
      untrusted: "No es Confiable",
      execute: "Ejecutar",
      discard: "Descartado",
      pause: "En pausa",
      success: "Éxito",
      error: "Fallido",
      waiting: "Esperando",
      next: "Seguinte",
      timeout: "Tiempo de espera",
      notStarted: "No iniciada",
      notStartedText: "Operación en espera de inicio",
      limit: "A espera en la cola",
      failedStart: "Error al inicio",
      failedStartText: "No se ha podido iniciar la operación",
      interrupted: "Interrumpido"
    },
    lastRan: "Última ejecución",
    progress: "Progreso del ataque",
    addAbility: "Añadir Habilidad",
    searchAnAbility: "Buscar una Habilidad",
    addCommand: "Añadir comando",
    paused: "En pausa",
    pending: "Pendiente",
    discarded: "Descartado",
    progressStatus: "Progreso",
    deleteTitle: "Borrar el ataque",
    deleteDescription:
      "Estás seguro de que quieres borrar el ataque {attackName}?",
    stopTitle: "Detener el ataque",
    stopDescription: "Está seguro de querer detener el ataque {attackName}?",
    failed: "Fallido",
    success: "Éxito",
    availableAgents: {
      totalAgents: "Agentes",
      placeholderSelectAgent: "Seleccione un agente disponible",
      titleModalUnavailableAgents: "No se encontró ningún agente disponible",
      descriptionModalUnavailableAgents:
        "Asegúrese de tener un agente disponible para poder implementar su ataque.",
      buttonActiveNewAgent: "Activar nuevo agente"
    },
    timelineFields: {
      platform: "OS",
      timestamps: "Marca de tiempo",
      status: "Status",
      ability: "Habilidad",
      agent: "Agente",
      host: "Host",
      pid: "pid",
      details: "Detalles"
    },
    nextInLine: "Seguinte en la fila",
    inProgress: "En curso",
    viewInfo: {
      loot: "Loot",
      buttonText: "Ver información",
      buttonTextRunningCommand: "Comando de Revisión",
      lootFields: {
        name: "Nombre",
        value: "Valor"
      },
      error: "Fallido"
    },
    reviewCommand: {
      approve: "Aprobar",
      reprove: "Desaprobar"
    },
    controls: {
      reload: "Reiniciar la Operación"
    },
    uncompletedOperation: {
      tooltip: "Ataque sin finalización",
      title: "Importante: Directrices de ataque",
      description:
        "Te has dado cuenta de que cuando terminaste el ataque planeado se completó, pero no alcanzó el 100% de progreso. Esto puede haber ocurrido por una de las siguientes razones:",
      reasons: {
        manuallyFinished: "El ataque fue terminado manualmente",
        agentConnectionLost: "Se ha perdido la conexión con el Agente",
        abilityCancelled:
          "El Skill fue cancelado. Ocurre cuando hacemos clic en “Siguiente”",
        abilityNotMatchSO: "Competencia incompatible con el sistema operativo"
      }
    },
    report: {
      modalDownload: {
        title: "Seleccione el formato del informe",
        pdfButton: "Descargar .PDF",
        csvButton: "Descargar .CSV"
      }
    },
    list: {
      title: "Ataque | Ataques",
      searchField: {
        attack_name: "Nombre del Ataque",
        adversary_name: "Nombre del Adversario",
        agent_name: "Nombre del Agente",
        ability_name: "Nombre de la Habilidade"
      },
      table: {
        attack_name: "Nombre del Ataque",
        adversary_name: "Oponente",
        operation_date: "Fecha",
        agent_name: "Agente",
        agent_so: "OS",
        qty_abilities: "Habilidades",
        success_percent: "Ataque %"
      }
    },
    reviewPage: {
      facts: "Fact | Facts",
      rules: "Rule | Rules",
      title: "Revise su Ataque",
      startAttack: "Iniciar el Ataque",
      factsAndRules: "Facts / Reglas",
      advancedConfiguration: "Ajustes Avanzados",
      variableUsed:
        "No hay {variable} que este Ataque pueda usar | {qty} {variable} que este Ataque pueda usar | {qty} {variable} que este Ataque pueda usar",
      addVariable: "Añadir {variable}",
      searchByVariable: "Buscar {variable}",
      obfuscatorPlaceholder: "Seleccione un Ofuscador disponible"
    }
  }
}
